import apiClient from './api'
import { AuthUser, CreateUserPayload, UserRole } from '@/types/auth'

export const userService = {
  async list(): Promise<AuthUser[]> {
    const { data } = await apiClient.get<AuthUser[]>('/admin/users')
    return data
  },
  async create(payload: CreateUserPayload): Promise<AuthUser> {
    const { data } = await apiClient.post<AuthUser>('/admin/users', payload)
    return data
  },
  async updateRole(userId: string, role: UserRole): Promise<AuthUser> {
    const { data } = await apiClient.patch<AuthUser>(`/admin/users/${userId}`, { role })
    return data
  },
  async delete(userId: string): Promise<void> {
    await apiClient.delete(`/admin/users/${userId}`)
  },
  async updatePassword(userId: string, password: string): Promise<void> {
    await apiClient.patch(`/admin/users/${userId}`, { password })
  },
}


